export const baseURL = process.env.REACT_APP_BASE_URL || ''
export const bucketName = process.env.REACT_APP_S3_BUCKET_NAME

export const urls = {
  GRADE_LIST: '/dashboard-grade-fsm/v1/grade?school_id=',
  SECTION_LIST: '/dashboard-grade-fsm/v1/grade/section?grade_map_id=',
  SCHOOL_POST: '/dashboard-school-fsm/v1/school',
  ADMIN_POST: '/dashboard-onboard-fsm/v1/onboard/employee',
  TEACHER_POST: '/dashboard-teacher-fsm/v1/teacher',
  TEACHER_PATCH: '/dashboard-teacher-fsm/v1/teacher',
  SECTION_POST: '/dashboard-teacher-fsm/v1/teacher/addSection',
  GRADE_POST: '/dashboard-grade-fsm/v1/grade/add',
  TEACHER_LIST: '/dashboard-teacher-fsm/v1/teacher',
  TEACHER_DELETE: '/dashboard-teacher-fsm/v1/teacher?teacher_id=',
  STUDENT_LIST: '/dashboard-student-fsm/v1/student?',
  SCHOOL_LIST: '/dashboard-school-fsm/v1/school',
  STUDENT_POST: '/dashboard-student-fsm/v1/student',
  SCHOOL_SEARCH: '/dashboard-school-fsm/v1/school/search?keyword=',
  STUDENT_SEARCH: '/dashboard-student-fsm/v1/student/search?search=',
  TEACHER_SERACH: '/dashboard-teacher-fsm/v1/teacher/search?search=',
  EMPLOYEE_GET: '/dashboard-employee-fsm/v1/employee?school_id=',
  EMPLOYEE_POST: '/dashboard-employee-fsm/v1/employee',
  EMPLOYEE_PATCH: '/dashboard-employee-fsm/v1/employee/update',
  EMPLOYEE_DELETE: '/dashboard-employee-fsm/v1/employee/delete?employee_id=',
  EMPLOYEE_SEARCH: '/dashboard-employee-fsm/v1/employee/search?keyword=',
  FEES_GET: '/dashboard-fee-fsm/v1/fee?',
  FEE_SEARCH: '/dashboard-fee-fsm/v1/fee?search=',
  FEE_DETAIL: '/dashboard-fee-fsm/v1/fee/detail?student_id=',
  FEE_STATUS: '/dashboard-fee-fsm/v1/fee/?status=',
  ADD_FEE: '/dashboard-fee-fsm/v1/fee',
  STUDENT_PATCH: '/dashboard-student-fsm/v1/student',
  STUDENT_DELETE: '/dashboard-student-fsm/v1/student?student_id=',
  STUDENT_STATUS_CHNAGE: '/dashboard-student-fsm/v1/student/status',
  ANALYTICS: '/dashboard-analytics-fsm/v1/analytics?school_id=',
  PIE_DATA: '/dashboard-analytics-fsm/v1/analytics/charts/totalStudent?school_id=',
  REVENUE: '/dashboard-analytics-fsm/v1/analytics/charts/revenue?school_id=',
  EXPENSE_CHART: '/dashboard-analytics-fsm/v1/analytics/charts/expense?school_id=',
  NEW_FEES: '/dashboard-analytics-fsm/v1/analytics/newFee?school_id=',
  FEE_CHART: '/dashboard-analytics-fsm/v1/analytics/charts/fee?school_id=',
  ALL_GRADES: '/dashboard-grade-fsm/v1/grade/allGrade',
  EXPENSE: '/dashboard-expense-fsm/v1/expense',
  EXPENSE_POST: '/dashboard-expense-fsm/v1/expense',
  EXPLOYEE_LIST: '/dashboard-expense-fsm/v1/expense/employee?school_id=',
  EXPENSE_DELETE: '/dashboard-expense-fsm/v1/expense?expense_id=',
  EXPENSE_PATCH: '/dashboard-expense-fsm/v1/expense',
  EXPENSE_SEARCH: '/dashboard-expense-fsm/v1/expense/search?search=',
  EXPENSE_CATEGORY_CHART: '/dashboard-expense-fsm/v1/expense/category?year=',
  ALL_SECTION: '/dashboard-grade-fsm/v1/grade/allSection',
  CLASS_GRADE: '/dashboard-grade-fsm/v1/grade/schoolGrade?school_id=',
  SECTION_TEACHER: '/dashboard-grade-fsm/v1/grade/teacher?school_id=',
  STAFF_LIST: '/dashboard-grade-fsm/v1/grade/staff?school_id=',
  SECTION_MAP: '/dashboard-grade-fsm/v1/grade/sectionMap?section_map_id=',
  ADD_SECTION: '/dashboard-grade-fsm/v1/grade/assignTeacher',
  CHECK_USER: '/dashboard-employee-fsm/v1/employee/verify',
  IMPORT: '/dashboard-student-fsm/v1/student/import',
  CLASS_DELETE: '/dashboard-grade-fsm/v1/grade/delete?grade_map_id=',
  SECTION_DELETE: '/dashboard-grade-fsm/v1/grade/section/delete?section_map_id=',
  UPDATE_GRADE: '/dashboard-grade-fsm/v1/grade/section/update?grade_map_id=',
  VAN_DRIVER_GET: '/dashboard-driver-fsm/v1/driver?school_id=',
  VAN_DRIVER_POST: '/dashboard-driver-fsm/v1/driver',
  DRIVER_PATCH: '/dashboard-driver-fsm/v1/driver',
  DRIVER_DELETE: '/dashboard-driver-fsm/v1/driver?employee_id=',
  DRIVER_SEARCH: '/dashboard-driver-fsm/v1/driver/search?school_id=',
  VAN_SEARCH: '/dashboard-van-fsm/v1/van/search?school_id=',
  ROUTE_SEARCH: '/dashboard-van-fsm/v1/van/route/search?school_id=',
  VAN_GET: '/dashboard-van-fsm/v1/van?school_id=',
  VAN_POST: '/dashboard-van-fsm/v1/van',
  VAN_PATCH: '/dashboard-van-fsm/v1/van',
  VAN_DELETE: '/dashboard-van-fsm/v1/van?van_id=',
  ROUTE_GET: '/dashboard-route-fsm/v1/route?school_id=',
  ROUTE_POST: '/dashboard-route-fsm/v1/route',
  ROUTE_PATCH: '/dashboard-route-fsm/v1/route',
  ROUTE_DELETE: '/dashboard-route-fsm/v1/route?route_id=',
  ATTENDER_GET: '/dashboard-employee-fsm/v1/employee?school_id=',
  PASSENGER_GET: '/dashboard-van-fsm/v1/van/passenger?van_id=',
  PASSENGER_POAST: '/dashboard-van-fsm/v1/van/passenger',
  PASSENGER_DELETE: '/dashboard-van-fsm/v1/van/passenger?student_id=',

  HOLIDAY_GET: '/dashboard-holiday-fsm/v1/holiday',
  HOLIDAY_DELETE: '/dashboard-holiday-fsm/v1/holiday',
  HOLIDAY_PATCH: '/dashboard-holiday-fsm/v1/holiday',
  HOLIDAY_POST: '/dashboard-holiday-fsm/v1/holiday',

  CREDIT_PAGE_GET: '/dashboard-credit-fsm/v1/credit',
  CREDIT_PAGE_BUY_POST: '/dashboard-credit-fsm/v1/credit/buy',
  CREDIT_ASSIGN: '/dashboard-credit-fsm/v1/credit/assign',
  CREDIT_SECTION_LIST: '/dashboard-credit-fsm/v1/credit/list',

  STOP_GET: '/dashboard-route-fsm/v1/route/stop?route_id=',
  STOP_DELETE: '/dashboard-route-fsm/v1/route/stop?stop_id=',
  STOP_PATCH: '/dashboard-route-fsm/v1/route/stop',
  STOP_POST: '/dashboard-route-fsm/v1/route/stop',
  STOP_DETAIL: '/dashboard-route-fsm/v1/route/stop/detail?stop_id=',
  STUDENT_STOP_GET: '/dashboard-route-fsm/v1/route/student?school_id=',

  INDIVIDUAL_STUDENT_FEES: '/dashboard-fee-fsm/v1/fee/student/detail?student_id=',
  FEE_ANALYTICS: '/dashboard-fee-fsm/v1/fee/analytics?school_id=',

  UPDATE_GRADE_FEES: '/dashboard-grade-fsm/v1/grade/fee',
  LOGIN: '/dashboard-employee-fsm/v1/employee/login',

  SUBJECT: '/dashboard-subject-fsm/v1/subject',

  TIMETABLE: '/dashboard-timetable-fsm/v1/timetable',

  TIMETABLE_VIEW_GET: '/dashboard-timetable-fsm/v1/timetable/view',

  PRESENCE_GET: '/dashboard-attendance-fsm/v1/attendance',

  TEACHER_PROFILE: '/dashboard-employee-fsm/v1/employee/profile',

  STUDENT_PROFILE: '/dashboard-student-fsm/v1/student/profile',

  TRANSPORT_STUDENT_GET: '/dashboard-van-fsm/v1/van/transport',

  ADD_TRANSPORT_LIST: '/dashboard-route-fsm/v1/route/student',

  AVAILAIBLE_TEACHER: '/dashboard-timetable-fsm/v1/timetable/available-teachers',
}

export const s3Confid = {
  region: process.env.REACT_APP_AWS_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_SECRET_KEY,
  },
}

export const getImageURL = (folder, fileName) => {
  return `${process.env.REACT_APP_S3_LINK}/${folder}/${fileName}`
}

export const upload_url = process.env.REACT_APP_UPLOAD_URL
